import { h, Component } from 'preact'
import InputGroup from '../ui-components/InputGroup'
import { Modal, ModalBody, ModalFooter, ModalHeader } from '../modal'
import ButtonControl from '../button-control'

interface ModalState {
  newName: string,
  error?: string
}

interface ModalProps {
  tag?: string,
  error?: string,
  onSave: (newValue: string) => void,
  onClose: () => void,
  onClick: () => void
}

export class EditModal extends Component<ModalProps, ModalState> {
  constructor (props: ModalProps) {
    super(props)
    this.state = {
      newName: props.tag || ''
    }
  }

  render ({ tag, onSave, onClose, onClick, error }: ModalProps, { newName }: ModalState) {
    return <Modal isOpen size='medium'>
      <ModalHeader title={tag ? `Edit public tag '${tag}'` : 'New public tag'} onClose={onClose} />
      <ModalBody>
        <InputGroup title='Tag name'
          placeholder='Add tag name'
          qaClasses='qa-add-tag-input'
          value={newName}
          onChange={(e: ChangeEvent) => this.setState({ newName: e.target.value })}
          onClick={onClick}
          maxlength={45}
          error={error}
        />

      </ModalBody>
      <ModalFooter>
        <ButtonControl
          class='qa-public-tag-save'
          title='Save changes'
          variant='success'
          onClick={() => onSave(newName)} />
        <ButtonControl
          class='qa-public-tag-cancel'
          title='Cancel'
          onClick={onClose} />
      </ModalFooter>
    </Modal>
  }
}

interface DeleteModalProps {
  tag: string,
  onDelete: () => void,
  onClose: () => void
}

export const DeleteModal = ({ tag, onDelete, onClose }: DeleteModalProps) => <Modal isOpen size='medium'>
  <ModalHeader title={`Delete public tag '${tag}'?`} onClose={onClose} />
  <ModalBody>All topics with this public tag previously will lose it.</ModalBody>
  <ModalFooter>
    <ButtonControl
      title='Delete'
      class='qa-public-tag-delete'
      variant='danger'
      onClick={onDelete} />
    <ButtonControl
      title='Cancel'
      class='qa-public-tag-cancel'
      onClick={onClose} />
  </ModalFooter>
</Modal>

interface State {
  newName: string,
  error?: string
}

interface Props {
  tag?: string,
  mergeCount: number,
  error?: string,
  onSave: (newValue: string) => void,
  onClose: () => void,
  onClick: () => void
}

export class MergeModal extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {
      newName: props.tag || ''
    }
  }

  render ({ tag, onSave, onClose, onClick, error, mergeCount }: Props, { newName }: State) {
    return <Modal isOpen size='medium'>
      <ModalHeader title={`Merge ${mergeCount} public tags`} onClose={onClose} />
      <ModalBody>
        <InputGroup title='Tag name'
          placeholder='Add tag name'
          qaClasses='qa-merge-tag-input'
          value={newName}
          onChange={(e: ChangeEvent) => this.setState({ newName: e.target.value })}
          onClick={onClick}
          maxlength={45}
          error={error}
        />

      </ModalBody>
      <ModalFooter>
        <ButtonControl
          class='qa-public-tag-merge'
          title='Save changes'
          variant='success'
          onClick={() => onSave(newName)} />
        <ButtonControl
          class='qa-public-tag-cancel'
          title='Cancel'
          onClick={onClose} />
      </ModalFooter>
    </Modal>
  }
}
